module.exports = __webpack_public_path__ + "img/client1.6ff2f32d.png";